/* 商品ページ関連商品カルーセルの矢印（sections/p-product-related-carousel.liquid）
   横送り自体は CSS scroll-snap。ここは PC の前後ボタンだけを担当する。
   <product-recommendations> が中身を差し替えた後も、カスタム要素なので自動で再接続される */
if (!customElements.get('p-related-carousel')) {
  customElements.define(
    'p-related-carousel',
    class extends HTMLElement {
      constructor() {
        super();
        this.update = this.update.bind(this);
        this.onPrev = () => this.go(-1);
        this.onNext = () => this.go(1);
      }

      connectedCallback() {
        this.track = this.querySelector('.js-related-carousel-track');
        this.prev = this.querySelector('.js-related-carousel-prev');
        this.next = this.querySelector('.js-related-carousel-next');
        if (!this.track || !this.prev || !this.next) return;

        this.prev.addEventListener('click', this.onPrev);
        this.next.addEventListener('click', this.onNext);
        this.track.addEventListener('scroll', this.update, { passive: true });
        this.observer = new ResizeObserver(this.update);
        this.observer.observe(this.track);
        this.update();
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        if (!this.track) return;
        this.prev.removeEventListener('click', this.onPrev);
        this.next.removeEventListener('click', this.onNext);
        this.track.removeEventListener('scroll', this.update);
      }

      go(dir) {
        const slide = this.track.querySelector('li');
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const step = slide ? slide.getBoundingClientRect().width + gap : this.track.clientWidth;
        const perView = Math.max(1, Math.floor((this.track.clientWidth + gap) / step));
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.track.scrollBy({ left: dir * step * perView, behavior: reduce ? 'auto' : 'smooth' });
      }

      update() {
        const max = this.track.scrollWidth - this.track.clientWidth;
        this.prev.parentElement.hidden = max <= 1;
        this.prev.disabled = this.track.scrollLeft <= 1;
        this.next.disabled = this.track.scrollLeft >= max - 1;
      }
    }
  );
}
